import {TABLE_SIZE_L, TABLE_SIZE_M, TABLE_SIZE_S, TABLE_SIZE_XS} from "../OfferteHelper";

export const headCells = (isPachetti) => [
    {
        id: "bulk-nome",
        text: "nome",
        width: isPachetti ? TABLE_SIZE_M : TABLE_SIZE_L,
        align: "left"
    },
    {
        id: "bulk-ca",
        text: isPachetti ? "costo" : "costo attivazione",
        width: isPachetti? TABLE_SIZE_XS : TABLE_SIZE_S,
        align: "left"
    },
    ...!isPachetti ? [{
        id: "bulk-cu",
        text: "canone unitario",
        width: TABLE_SIZE_S,
        align: "left"
    }] : [],
    {
        id: "bulk-numero-sim",
        text: "numero sim (Attive)",
        width: isPachetti ? TABLE_SIZE_L : TABLE_SIZE_M,
        align: `left`
    },
    ...!isPachetti ? [{
        id: "bulk-tipologia",
        text: "tipologia",
        width: TABLE_SIZE_M,
        align: "left"
    }] : []
]

export const headCellsPiano = [
    {
        id: "bulk-nome",
        text: "nome",
        width: TABLE_SIZE_M,
        align: "left"
    },
    {
        id: "bulk-nu",
        text: "numero sim",
        width: TABLE_SIZE_XS,
        align: "left"
    },
    {
        id: "bulk-tipo",
        text: "tipologia",
        width: TABLE_SIZE_S,
        align: "left"
    },
    {
        id: "bulk-cu",
        text: "canone unitario",
        width: TABLE_SIZE_S,
        align: "left"
    },
    {
        id: "bulk-ca",
        text: "costo attivazione",
        width: TABLE_SIZE_S,
        align: "left"
    },
    {
        id: "bulk-button",
        text: "",
        width: TABLE_SIZE_XS,
        align: "right"
    }
]